import { responsiveVariables } from "../../../utilities/props.js";
import "./textAlign.css";
const textAlign = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-text-align", value),
    };
};
export default textAlign;
